import i18n from 'i18next';

import type { MessagesType, MessageType } from '../types';

const notaryMessages = {
  getPreferredNotary(): MessagesType {
    return {
      errorMessage: {
        message: 'messages.notary.getPreferredNotaryFailed',
      },
    };
  },
  getNotaries(): MessagesType {
    return {
      errorMessage: {
        message: 'messages.notary.getNotariesFailed',
      },
    };
  },
  updateMailConfiguration(): MessagesType {
    return {
      errorMessage: {
        message: 'messages.notary.mailConfigurationChangedFailed',
      },
      successMessage: {
        message: 'messages.notary.mailConfigurationChangedSuccess',
      },
    };
  },
  deleteEmail(): MessagesType {
    return {
      errorMessage: {
        message: 'messages.notary.deleteEmailFailed',
      },
      successMessage: {
        message: 'messages.notary.deleteEmailSuccess',
      },
    };
  },
  updatePreferredNotary(): MessagesType {
    return {
      errorMessage: {
        message: 'messages.notary.updatePreferredNotaryFailed',
      },
    };
  },
  addNotaryStudyContact(contactName: string): MessagesType {
    return {
      errorMessage: {
        message: 'messages.notary.addNotaryStudyContactFailed',
      },
      successMessage: {
        message: i18n.t('messages.notary.addNotaryStudyContactSuccess', {
          contactName,
        }),
      },
    };
  },
  pushNotaryDocuments({
    documentName,
    userName,
    numberOfDocuments,
    count,
  }: {
    documentName: string;
    userName: string;
    numberOfDocuments: number;
    count: number;
  }): MessagesType {
    const successMessageTranslationKey =
      numberOfDocuments === 1
        ? 'messages.notary.pushNotaryDocumentsSuccess.singleDoc'
        : 'messages.notary.pushNotaryDocumentsSuccess.multiDoc';
    const successMessage: MessageType['message'] = [
      successMessageTranslationKey,
      {
        documentName,
        userName,
        numberOfDocuments,
        count,
      },
    ];
    return {
      successMessage: {
        message: successMessage,
      },
      errorMessage: {
        message: 'messages.notary.pushNotaryDocumentsFailed',
      },
    };
  },
};

export default notaryMessages;
